<template lang="pug">
div
    grid-table-component(
        :headers='headers',
        :data='paginacao.processos',
        :is-paginated='true',
        :is-loading='isLoading',
        :pagination='setPagination()',
        @table:page-changed='checkPaginationChange($event)'
    )
        template(v-slot:processoSelecionado='{ item }')
            checkbox-input-component(v-model='item') 

        template(v-slot:statusImovel='{ item }')
            span.status-imovel(
                v-if='item.statusImovel'
                v-tooltip="{ label: StatusImovelEnum[item.statusImovel]?.nome, position: 'bottom' }"
                :style="{ backgroundColor: StatusImovelEnum[item.statusImovel]?.color, color: '#FFFFFF' }"
            ) {{ StatusImovelEnum[item.statusImovel].id }}

        template(v-slot:codigoImovel='{ item }')
            span(v-tooltip='{ label: item.codigoImovel, position: "bottom", minWidth: "360px" }') {{ item.codigoImovel | ellipsis(6, 4) }}

        template(v-slot:copiarCodigoImovel='{ item }')
            span(v-tooltip='{ label: "Copiar", position: "bottom", minWidth: "30px" }')
                button-component.copy-button(
                    label='',
                    icon='mdi-content-copy',
                    color='green',
                    @click.native='copyClipboard(item)'
                )

        template(v-slot:areaTotalCompensar='{ item }')
            span {{ item.areaTotalCompensar | decimal }}

        template(v-slot:areaTotalRecompor='{ item }')
            span {{ item.areaTotalRecompor | decimal }}

        template(v-slot:dataEnvioProposta='{ item }')
            span {{ item.dataEnvioProposta | data }}

        template(v-slot:dataAsinaturaTC='{ item }')
            span {{ item.data_assinatura | data }}

        template(v-slot:dataVinculoTecnico='{ item }')
            span {{ getTecnicoProcessoInfo(item).dataVinculacao | data }}

        template(v-slot:condicaoInscricao='{ item }')
            span {{ getCondicaoInscricaoLabel(item.condicaoInscricao) }}

        template(v-slot:condicao='{ item }')
            .actions-check
                chip-component(
                    v-if='getConditionLabel(item.condicao).tooltip',
                    :label='getConditionLabel(item.condicao).label',
                    :background-color='getConditionLabel(item.condicao).chipColor',
                    v-tooltip='{ label: getConditionLabel(item.condicao).tooltip, position: "bottom" }',
                    width='150px'
                )
                chip-component(
                    v-else,
                    :label='getConditionLabel(item.condicao).label',
                    :background-color='getConditionLabel(item.condicao).chipColor',
                    width='150px'
                )

        template(v-slot:acao='{ item }')
            .actions-check
                dropdown-component(
                    :list='montarAcoes(item.acoes, item.statusImovel)',
                    @input='onAction($event, item)',
                    :props='{ label: "nome" }',
                    :is-select='false',
                    position='left'
                )
        template(v-slot:devolutiva='{ item }')
            .devolutiva(v-if='item.dtVisualizacaoNotificacao')

                template(v-if='item.isProprietarioECompromissarioAssinaram && !item.faltaAssinaturaGO')
                    span(:class='diasRestantes(item) >= 0 ? "verde" : "vermelho"')
                        | Assinado com
                        br
                        b {{ diasGastosAteAssinatura(item) }} dias
                template(v-else)
                    template(v-if='diasRestantes(item) >= 0')

                        el-tooltip(
                            v-if='item.isProprietarioECompromissarioAssinaram && item.faltaAssinaturaGO'
                            placement="top"
                            popper-class="tooltip-termo-expirado"
                        )
                            template(#content)
                                .tooltip-box
                                    .tooltip-icone.amarelo
                                        i.mdi.mdi-alert
                                    .tooltip-texto
                                        | O Termo de Compromisso aguarda apenas a assinatura do GO
                                        br
                                        | para ser concluído

                            span.verde
                                | Dentro do prazo
                                br
                                b + {{ diasRestantes(item) }} dias

                        span.verde(v-else)
                            | Dentro do prazo
                            br
                            b + {{ diasRestantes(item) }} dias

                    template(v-else)

                        el-tooltip(
                            v-if='item.isProprietarioECompromissarioAssinaram && item.faltaAssinaturaGO'
                            placement="top"
                            popper-class="tooltip-termo-expirado"
                        )
                            template(#content)
                                .tooltip-box
                                    .tooltip-icone.amarelo
                                        i.mdi.mdi-alert
                                    .tooltip-texto
                                        | O Termo de Compromisso aguarda apenas a assinatura do GO
                                        br
                                        | para ser concluído

                            span.vermelho
                                | Prazo expirado
                                br
                                b - {{ Math.abs(diasRestantes(item)) }} dias

                        el-tooltip(
                            v-else
                            placement="top"
                            popper-class="tooltip-termo-expirado"
                        )
                            template(#content)
                                .tooltip-box
                                    .tooltip-icone
                                        i.mdi.mdi-clock-outline
                                    .tooltip-texto
                                        | O prazo para assinatura
                                        br
                                        | do termo está vencido

                            span.vermelho
                                | Prazo expirado
                                br
                                b - {{ Math.abs(diasRestantes(item)) }} dias

                span(v-else) --
    modal-component(
        v-if='modalVinculacaoTecnico',
        title='Vinculação de Técnico para Análise',
        @close='cancelarModalVinc'
    )
        ModalVinculacaoTecnicoComponent(:processos='processosSelecionados', @cancelar='cancelarModalVinc()', @atualizarGrid='pesquisar()')

    modal-component(
        v-if='modalConfirmacao',
        :title='`CAR: <b>${processo.codigoImovel}</b>`',
        @close='modalConfirmacao = false',
        width='35rem'
    )
        .modal-confirmacao
            span Vinculação: #[i {{ getTecnicoProcessoInfo(processo).dataVinculacao | data }}]
            p Despacho: #[i {{ getTecnicoProcessoInfo(processo).despacho }}]
            .mensagem-modal
                b Você tem certeza de que deseja iniciar a análise?
            .footer

        .modal-footer(:style='[ { display: "flex" },  { justifyContent: "space-between" }, { marginTop: "30px" } ]')
            button-component(
                label='Cancelar',
                icon='mdi-close',
                background-color='var(--primary-gray)',
                color='var(--primary-light-smoke)',
                @click.native='modalConfirmacao = false'
            )
            button-component(label='Confirmar', icon='mdi-check', @click.native='iniciarAnaliseProposta')

    modal-component(
        v-if='modalAssinaturas',
        title='Minuta do Termo de compromisso',
        width='80%'
        @close='modalAssinaturas = false'
    )
        AssinaturaTermoCompromisso(:processo='processo', @cancelar='cancelarModalTC()')

    modal-component(
        v-if='modalDocumentosAnalise',
        title='Documentos da análise',
        width='35rem'
        @close='modalDocumentosAnalise = false'
    )
        ModalDocumentosAnalise(:infoProcesso='infoProcesso', @cancelar='modalDocumentosAnalise = false')

    modal-component(
        v-if='modalExportarShape',
        title='Exportar shape',
        @close='modalExportarShape = false',
        width='35rem'
    )
        ModalExportarShapeAreasRecompor(:codigoImovel='this.processo.codigoImovel', @close='modalExportarShape = false')

    modal-component(
        v-if='modalSuspenderCancelarImovel',
        :title='tituloModalSuspenderCancelarImovel',
        @close='modalSuspenderCancelarImovel = false',
        width='35rem'
    )
        ModalSuspenderCancelarImovel(
            :codigoImovel='processo.codigoImovel', 
            @close='modalSuspenderCancelarImovel = false',
            @atualizar='modalSuspenderCancelarImovel = false; pesquisar()',
            :acao='acaoModalSuspenderCancelarImovel',
            :idProcesso='processo.id'
        )
    modal-component(
        v-if='modalSolicitacaoNovaAnalise',
        title='Solicitar nova análise',
        @close='modalSolicitacaoNovaAnalise = false',
        width='35rem'
    )
        ModalSolicitacaoNovaAnalise(
            :codigoImovel='processo.codigoImovel', 
            @close='modalSolicitacaoNovaAnalise = false',
            @atualizar='modalSolicitacaoNovaAnalise = false; pesquisar()',
            :idProcesso='processo.id'
        )
    .linha.justify-end
            button-component(
                v-if='mostrarFaseProcesso',
                label='Vincular técnico para análise', 
                icon='mdi-magnify', 
                @click.native='vincularProcessos', 
                :disabled='!possuiProcessoSelecionado'
            )
</template>

<script>
import { buscarUrlAcessoFichaImovel } from '@/services/ficha-imovel.service';
import { iniciarAnalise, downloadDemonstrativoSicar } from '@/services/processo.service';
import ModalExportarShapeAreasRecompor from './ModalExportarShapeAreasRecompor.vue';
import ModalVinculacaoTecnicoComponent from '@/views/caixaEntrada/components/ModalVinculacaoTecnicoComponent.vue';
import ModalSuspenderCancelarImovel from './ModalSuspenderCancelarImovel.vue';
import ModalSolicitacaoNovaAnalise from './ModalSolicitacaoNovaAnalise.vue';
import AssinaturaTermoCompromisso from '@/views/assinatura/AssinaturaTermoCompromisso.vue';
import ModalDocumentosAnalise from '@/views/caixaEntrada/components/ModalDocumentosAnalise.vue';
import { AcaoEnum, CondicaoEnum, CondicaoInscricaoEnum } from '@/enums/processo.enum.js';
import {consultarProcessos} from '@/utils/breadcrumb.utils';
import { StatusImovelEnum } from '@/enums/status-imovel.enum';

export default {
    name: 'CaixaEntradaTableComponent',

    components: {
        AssinaturaTermoCompromisso,
        ModalVinculacaoTecnicoComponent,
        ModalDocumentosAnalise,
        ModalExportarShapeAreasRecompor,
        ModalSuspenderCancelarImovel,
        ModalSolicitacaoNovaAnalise
    },

    props: {
        headers: {
            type: Array,
            default: null,
        },

        data: {
            type: Array,
            default: null,
        },

        paginacao: {
            type: Object,
            default: () => ({
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                processos: [],
            }),
        },

        mostrarFaseProcesso: {
            type: Boolean,
            default: false
        },

        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modalVinculacaoTecnico: false,
            modalConfirmacao: false,
            modalAssinaturas: false,
            modalDocumentosAnalise: false,
            processos: [],
            infoProcesso: null,
            modalExportarShape: false,
            modalSuspenderCancelarImovel: false,
            modalSolicitacaoNovaAnalise: false,
            tituloModalSuspenderCancelarImovel: '',
            acaoModalSuspenderCancelarImovel: null,
            StatusImovelEnum
        };
    },
    methods: {
        async onAction(event, processo) {
            this.processo = processo;
            switch (event.id) {
                case AcaoEnum.VISUALIZAR_FICHA_IMOVEL.id:
                    buscarUrlAcessoFichaImovel(processo.id).then((response) => {
                        window.open(response, '_blank');
                    });
                    break;
                case AcaoEnum.VINCULAR_TECNICO.id:
                    this.modalVinculacaoTecnico = true;
                    break;
                case AcaoEnum.ANALISAR.id:
                    if ((this.processo.condicao === CondicaoEnum.EM_ANALISE.id) ||
                        (this.processo.condicao === CondicaoEnum.EM_REANALISE.id) ) {
                        this.irParaAnalise();
                        return;
                    }
                    this.modalConfirmacao = true;
                    break;
                case AcaoEnum.VISUALIZAR_TERMO_COMPROMISSO.id:
                    this.modalAssinaturas = true;
                    break;
                case AcaoEnum.VALIDAR.id:
                case AcaoEnum.VISUALIZAR_ANALISE.id:
                    this.irParaAnalise();
                    break;
                case AcaoEnum.VISUALIZAR_DOCUMENTOS.id:
                    this.infoProcesso = {
                        id: processo.id,
                        condicao: processo.condicao,
                        codigoImovel: processo.codigoImovel
                    };
                    this.modalDocumentosAnalise = true;
                    break;
                case AcaoEnum.DOWNLOAD_TERMO_COMPROMISSO.id:
                    try {
                        const response = await buscarInformacoesAnalise(processo.id);

                        if (response != null) {
                            await downloadDocumento(response.caminhoTermoCompromisso, "Termo_de_compromisso.pdf");
                        } else {
                            this.$toast({
                                showClose: true,
                                message: "Erro ao fazer o download do Termo de Compromisso.",
                                type: type
                            });
                        }

                    } catch (error) {

                        this.$toast({
                            showClose: true,
                            message: "Ocorreu um erro ao buscar informações da análise" + error.message,
                            type: type
                        });
                    }
                    break;
                case AcaoEnum.VISUALIZAR_ANALISE_HISTORICO.id:
                    this.modalDocumentosAnalise = true;
                    this.$router.push({ name: 'analise-historico', params: { idProcesso: processo.id } });
                    break;
                case AcaoEnum.BAIXAR_DEMONSTRATIVO_IMOVEL.id:
                    this.downloadDemonstrativo(processo.codigoImovel);
                    break;
                case AcaoEnum.EXPORTAR_AREAS_RECOMPOR.id:
                    this.modalExportarShape = true;
                    break;
                case AcaoEnum.SUSPENDER_IMOVEL.id:
                case AcaoEnum.CANCELAR_IMOVEL.id:
                case AcaoEnum.REVERTER_SUSPENSAO_IMOVEL.id:
                    this.tituloModalSuspenderCancelarImovel = AcaoEnum[event.id].nome;
                    this.acaoModalSuspenderCancelarImovel = event.id;
                    this.modalSuspenderCancelarImovel = true;
                    break;
                case AcaoEnum.SOLICITAR_NOVA_ANALISE.id:
                    this.modalSolicitacaoNovaAnalise = true;
                    break;
                default:
                    break;
            }
        },

        async downloadDocumento(path, name) {
            const documento = await downloadDocumento(path);
            var file = window.URL.createObjectURL(new Blob([documento.data]));
            var docUrl = document.createElement('a');
            docUrl.href = file;
            docUrl.setAttribute('download', name);
            document.body.appendChild(docUrl);
            docUrl.click();
        },

        checkPaginationChange({ page }) {
            this.$emit('inbox:page-change', page);
        },

        setPagination() {
            return {
                page: this.paginacao.pagina,
                totalPages: this.paginacao.numeroPaginas,
                itemsPerPage: this.paginacao.quantidadePagina,
                totalItems: this.paginacao.total,
                order: 'ASC',
            };
        },

        getConditionLabel(condicao) {
            const condicaoEnum = CondicaoEnum[condicao] || {};
            return {
                label: condicaoEnum.label,
                tooltip: condicaoEnum.nome,
                chipColor: condicaoEnum.color,
            };
        },

        getCondicaoInscricaoLabel(idCondicaoInscricao) {
            const condicaoInscricao = Object.values(CondicaoInscricaoEnum).find(item => item.id === idCondicaoInscricao);
            return condicaoInscricao ? condicaoInscricao.label : "Desconhecido";
        },

        async iniciarAnaliseProposta() {
            await iniciarAnalise(this.processo.id);
            this.irParaAnalise();
        },

        irParaAnalise() {
            this.$router.push({
                name: 'analise',
                params: { id: this.processo.id },
            });
        },

        montarAcoes(acoes, status) {
            function compare(a, b) {
                if (a.nome < b.nome)
                    return -1;
                if (a.nome > b.nome)
                    return 1;
                return 0;
            }

            let acoesValidas = acoes.filter(acao => acao != null);

            if (this.$route.meta.titulo === consultarProcessos[1].label) {
                acoesValidas = acoesValidas
                    .filter((acao) => ![AcaoEnum.VALIDAR.id,
                        AcaoEnum.ANALISAR.id,
                        AcaoEnum.VINCULAR_TECNICO.id,
                        AcaoEnum.VISUALIZAR_TERMO_COMPROMISSO.id,
                        AcaoEnum.DOWNLOAD_TERMO_COMPROMISSO.id].includes(acao))
                    .map((acao) => AcaoEnum[acao])
                    .filter(acao => acao != null);

                return this.filtrarAcoesPorStatusImovel(acoesValidas, status).sort(compare);

            } else {
                acoesValidas = acoesValidas
                    .map((acao) => AcaoEnum[acao])
                    .filter(acao => acao != null);

                return this.filtrarAcoesPorStatusImovel(acoesValidas, status);
            }
        },

        filtrarAcoesPorStatusImovel(acoes, status) {
            return acoes.filter((acao) => {
                if (acao.id === AcaoEnum.SUSPENDER_IMOVEL.id) return status === 'AT';
                if (acao.id === AcaoEnum.REVERTER_SUSPENSAO_IMOVEL.id) return status === 'SU';
                return true;
            });
        },

        cancelarModalTC() {
            this.modalAssinaturas = false;
        },

        cancelarModalVinc() {
            this.modalVinculacaoTecnico = false
            this.processos = [];
            this.processo = null;
        },

        pesquisar() {
            this.checkPaginationChange({ page: this.paginacao.pagina });
        },

        copyClipboard(item) {
            navigator.clipboard.writeText(item.codigoImovel);
            this.$toast({
                showClose: true,
                message: 'Código Copiado',
                type: 'success'
            });
        },

        vincularProcessos() {
            this.modalVinculacaoTecnico = true;
        },

        getTecnicoProcessoInfo(processo) {
            if (processo.tecnicosProcesso && processo.tecnicosProcesso.length > 0) {
                const tecnico = processo.tecnicosProcesso.find(t => t.id_usuario_tecnico === this.$eu().id) || processo.tecnicosProcesso[0];
                return {
                    despacho: tecnico.despacho,
                    dataVinculacao: tecnico.data_vinculacao,
                };
            }
            return { despacho: '', dataVinculacao: processo?.dataVinculacao ?? '' };
        },
        async downloadDemonstrativo(codigoImovel) {
            const documento = await downloadDemonstrativoSicar(codigoImovel);
            let filename = documento?.headers['content-disposition'];                
            var file = window.URL.createObjectURL(new Blob([documento?.data]));
            var docUrl = document.createElement('a');
            docUrl.href = file;
            docUrl.setAttribute('download', filename);
            document.body.appendChild(docUrl);
            docUrl.click();
        },
        diasRestantes(item) {
            const prazo = 90;

            const dataVisualizacao = new Date(item.dtVisualizacaoNotificacao);
            const dataFim = item.dataAssinaturaGO
                ? new Date(item.dataAssinaturaGO)
                : new Date();
            const diff = Math.floor((dataFim - dataVisualizacao) / (1000 * 60 * 60 * 24));

            return prazo - diff;
        },
        diasGastosAteAssinatura(item) {
            if (!item.dtAssinaturaGO) return null;

            const dataVisualizacao = new Date(item.dtVisualizacaoNotificacao);
            const dataAssinatura = new Date(item.dtAssinaturaGO);

            return Math.floor((dataAssinatura - dataVisualizacao) / (1000 * 60 * 60 * 24));
        }
    },
    computed: {

        possuiProcessoSelecionado() {
            return this.data.some(processo => processo.selecionado);
        },

        processosSelecionados() {
            if (this.processo) {
                this.processos = [];
                this.data.forEach(processo => {
                  processo.selecionado = false;
                });
                this.processos.push(this.processo);
                return this.processos;
            }
            return this.data.filter(processo => processo.selecionado);
        }
    }
};
</script>
<style lang="scss" scoped>
.copy-button {
    background-color: transparent !important;
    box-shadow: none !important;
}

.modal-tecnico {
    color: var(--primary-black);
}

.subtitle-modal-tecnico {
    font-weight: 600;
    margin-bottom: 15px;
}

.processo {
    margin: 5px 0px 20px 0px;
}

.modal-tecnico .--loading {
    background-color: var(--primary-smoke);
    background-image: url('../../../assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
    content: '';
}

.input-despacho {
    margin: 15px 0px;
}

.status-imovel {
    padding: 3px 5px;
    border-radius: 2px;
    font-size: 9px;
}

.verde {
  color: #2e7d32;
}

.vermelho {
  color: #c62828;
  cursor: pointer;
}

.tooltip-box {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.tooltip-icone {
  width: 18px;
  height: 18px;
  background: #c04b4b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.tooltip-texto {
  font-size: 13px;
  line-height: 1.3;
}

:global(.el-tooltip__popper.tooltip-termo-expirado) {
  background: #F4E6C8 !important;
  border: 1px solid #D7C29E !important;
  color: #333 !important;
}

:global(.el-tooltip__popper.tooltip-termo-expirado .popper__arrow::after) {
  border-top-color: #F4E6C8 !important;
  border-bottom-color: #F4E6C8 !important;
}
.tooltip-icone.amarelo {
  background: #f9a825;
}
</style>

